import { NavLink } from 'react-router-dom';

function PromoBanner({ bannerImg1, bannerImg2 }) {
  return (
    <div className="container-fluid">
      <div className="row promo_card gx-3">
        <div className="col-lg-6 col-md-6 col-sm-12 position-relative">
          <img
            src={bannerImg1}
            className="d-block w-100 img-fluid rounded"
            alt="Promo 1"
          />
          <div className="promo_card_left_link">
            <NavLink to="/shop/" className="promo_card_btn">
              Shop Now
            </NavLink>
          </div>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12 position-relative mt-3 mt-md-0">
          <img
            src={bannerImg2}
            className="d-block w-100 img-fluid rounded"
            alt="Promo 2"
          />
          <div className="promo_card_right_link">
            <NavLink to="/shop/" className="promo_card_btn">
              Shop Now
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PromoBanner;
